import { description } from './description';
import { details } from './details';
import { files } from './files';
import { inventory } from './inventory';
import { materials } from './materials';
import { personalization } from './personalization';
import { photos } from './photos';
import { seo } from './seo';
import { shipping } from './shipping';
import { tags } from './tags';
import { title } from './title';
import { variations } from './variations';
import { videos } from './videos';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { OPERATIONS } from '@/constants/product';

export function applyOperationToProduct(props) {
  const { operation, product, ...rest } = props;
  const channel = product.get('channel');
  const operationType = operation.get('type');

  switch (channel) {
    case EBAY: {
      switch (operationType) {
        case OPERATIONS[EBAY].CONDITION_ID:
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION:
        case OPERATIONS[EBAY].ITEM_CATEGORY:
        case OPERATIONS[EBAY].ITEM_SPECIFICS.UPDATE:
        case OPERATIONS[EBAY].PRODUCT_DETAILS.UPDATE:
        case OPERATIONS[EBAY].STORE_CATEGORY: {
          return details(props);
        }

        case OPERATIONS[EBAY].DESCRIPTION: {
          return description(props);
        }

        case OPERATIONS[EBAY].PHOTOS.CHANGE_TO: {
          return photos(props);
        }

        case OPERATIONS[EBAY].PRICE:
        case OPERATIONS[EBAY].QUANTITY:
        case OPERATIONS[EBAY].SKU: {
          return inventory(props);
        }

        case OPERATIONS[EBAY].COUNTRY:
        case OPERATIONS[EBAY].DEPTH:
        case OPERATIONS[EBAY].IRREGULAR:
        case OPERATIONS[EBAY].LENGTH:
        case OPERATIONS[EBAY].LOCATION:
        case OPERATIONS[EBAY].PAYMENT_POLICY:
        case OPERATIONS[EBAY].POSTAL_CODE:
        case OPERATIONS[EBAY].RETURN_POLICY:
        case OPERATIONS[EBAY].SHIPPING_POLICY:
        case OPERATIONS[EBAY].WEIGHT_MAJOR:
        case OPERATIONS[EBAY].WEIGHT_MINOR:
        case OPERATIONS[EBAY].WIDTH: {
          return shipping(props);
        }

        case OPERATIONS[EBAY].TITLE: {
          return title(props);
        }

        case OPERATIONS[EBAY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[EBAY].VIDEOS.CHANGE_TO: {
          return videos(props);
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case ETSY: {
      switch (operationType) {
        case OPERATIONS[ETSY].CATEGORY:
        case OPERATIONS[ETSY].DIGITAL:
        case OPERATIONS[ETSY].IS_SUPPLY:
        case OPERATIONS[ETSY].PRODUCTION_PARTNERS:
        case OPERATIONS[ETSY].SECTION:
        case OPERATIONS[ETSY].SHOULD_AUTO_RENEW:
        case OPERATIONS[ETSY].TAXONOMY_ATTRIBUTES:
        case OPERATIONS[ETSY].WHO_MADE:
        case OPERATIONS[ETSY].WHEN_MADE: {
          return details(props);
        }

        case OPERATIONS[ETSY].DESCRIPTION: {
          return description(props);
        }

        case OPERATIONS[ETSY].FILES.CHANGE_TO: {
          return files(props);
        }

        case OPERATIONS[ETSY].MATERIALS.CHANGE_TO: {
          return materials(props);
        }

        case OPERATIONS[ETSY].PERSONALIZATION.CHAR_COUNT_MAX_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.IS_PERSONALIZABLE_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.IS_REQUIRED_SET:
        case OPERATIONS[ETSY].PERSONALIZATION_QUESTIONS: {
          return personalization(props);
        }

        case OPERATIONS[ETSY].PHOTOS.CHANGE_TO: {
          return photos(props);
        }

        case OPERATIONS[ETSY].PRICE:
        case OPERATIONS[ETSY].QUANTITY:
        case OPERATIONS[ETSY].SKU: {
          return inventory(props);
        }

        case OPERATIONS[ETSY].PROCESSING_PROFILE:
        case OPERATIONS[ETSY].SHIPPING_PROFILE:
        case OPERATIONS[ETSY].RETURN_POLICY:
        case OPERATIONS[ETSY].HEIGHT:
        case OPERATIONS[ETSY].LENGTH:
        case OPERATIONS[ETSY].WEIGHT:
        case OPERATIONS[ETSY].WIDTH: {
          return shipping(props);
        }

        case OPERATIONS[ETSY].TAGS.CHANGE_TO: {
          return tags(props);
        }

        case OPERATIONS[ETSY].TITLE: {
          return title(props);
        }

        case OPERATIONS[ETSY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[ETSY].VIDEOS.CHANGE_TO: {
          return videos(props);
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case FAIRE: {
      switch (operationType) {
        case OPERATIONS[FAIRE].CASE_SIZE:
        case OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY: {
          return shipping(props);
        }

        case OPERATIONS[FAIRE].CATEGORY: {
          return details(props);
        }

        case OPERATIONS[FAIRE].CONTINUE_SELLING:
        case OPERATIONS[FAIRE].DEADLINE_DATE:
        case OPERATIONS[FAIRE].DISTANCE_UNIT:
        case OPERATIONS[FAIRE].END_DATE:
        case OPERATIONS[FAIRE].GTIN:
        case OPERATIONS[FAIRE].HEIGHT:
        case OPERATIONS[FAIRE].KEEP_ACTIVE:
        case OPERATIONS[FAIRE].LENGTH:
        case OPERATIONS[FAIRE].MASS_UNIT:
        case OPERATIONS[FAIRE].PREORDER:
        case OPERATIONS[FAIRE].QUANTITY:
        case OPERATIONS[FAIRE].RESTOCK_DATE:
        case OPERATIONS[FAIRE].PRICES:
        case OPERATIONS[FAIRE].SKU:
        case OPERATIONS[FAIRE].START_DATE:
        case OPERATIONS[FAIRE].TARIFF_CODE:
        case OPERATIONS[FAIRE].WEIGHT:
        case OPERATIONS[FAIRE].WIDTH: {
          return inventory(props);
        }

        case OPERATIONS[FAIRE].DESCRIPTION: {
          return description(props);
        }

        case OPERATIONS[FAIRE].PHOTOS.CHANGE_TO: {
          return photos(props);
        }

        case OPERATIONS[FAIRE].TITLE: {
          return title(props);
        }

        case OPERATIONS[FAIRE].VARIATIONS: {
          return variations(props);
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case SHOPIFY: {
      switch (operationType) {
        case OPERATIONS[SHOPIFY].BARCODE:
        case OPERATIONS[SHOPIFY].CAP:
        case OPERATIONS[SHOPIFY].CHARGE_TAX:
        case OPERATIONS[SHOPIFY].CONTINUE_SELLING:
        case OPERATIONS[SHOPIFY].COUNTRY_CODE:
        case OPERATIONS[SHOPIFY].CPI:
        case OPERATIONS[SHOPIFY].HS_CODE:
        case OPERATIONS[SHOPIFY].PHYSICAL:
        case OPERATIONS[SHOPIFY].PRICE:
        case OPERATIONS[SHOPIFY].QUANTITY:
        case OPERATIONS[SHOPIFY].SKU:
        case OPERATIONS[SHOPIFY].TRACK_QUANTITY:
        case OPERATIONS[SHOPIFY].WEIGHT: {
          return inventory(props);
        }

        case OPERATIONS[SHOPIFY].DESCRIPTION: {
          return description(props);
        }

        case OPERATIONS[SHOPIFY].CATEGORY:
        case OPERATIONS[SHOPIFY].COLLECTIONS:
        case OPERATIONS[SHOPIFY].PRODUCT_TYPE:
        case OPERATIONS[SHOPIFY].VENDOR: {
          return details(props);
        }

        case OPERATIONS[SHOPIFY].META_DESCRIPTION:
        case OPERATIONS[SHOPIFY].PAGE_TITLE: {
          return seo(props);
        }

        case OPERATIONS[SHOPIFY].PHOTOS.CHANGE_TO: {
          return photos(props);
        }

        case OPERATIONS[SHOPIFY].TAGS.CHANGE_TO: {
          return tags(props);
        }

        case OPERATIONS[SHOPIFY].TITLE: {
          return title(props);
        }

        case OPERATIONS[SHOPIFY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[SHOPIFY].VIDEOS.CHANGE_TO: {
          return videos(props);
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    default: {
      return { product, ...rest };
    }
  }
}
